// Styles for Navigation go here.
import styled, { css } from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

//Adding some styles here as they are removed from shared/mi-ui-library
//TODO: we can move the alphaColor to common
const alphaColor = {
  gray1: 'rgba(28, 28, 28, 0.56)',
  gray2: 'rgba(28, 28, 28, 0.83)',
  gray3: 'rgba(28, 28, 28, 0.65)',
};

const headerHeights = css`
  height: ${toRem(52)};
  @media ${baseVariables.mediaQuery.sm} {
    height: ${toRem(88)};
  }
`;

export const StyledNavigationPlaceholder = styled.div`
  ${headerHeights}
`;

export const StyledNavigationContainer = styled.div<{ isBrandedVariation: boolean }>`
  z-index: 49;

  &.header-transparent {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    backdrop-filter: blur(${toRem(4)});
  }

  ${({ isBrandedVariation }) =>
    !isBrandedVariation
      ? `&.default-background {
    background-color: ${alphaColor['gray3']}; /* TODO: Update this value to use brand global style or one from shared ui */
    transition: background-color 0.3s ease-in-out;
  }`
      : ''}
  }

  &.standard {
    transition: background-color 0.3s ease-in-out;

    header {
      border-bottom: 1px solid ${baseVariables.color['neutral20']};
    }
  }

  header {
    ${headerHeights}
    order: 1;
  }

  @keyframes slideIn {
    from {
      transform: translateY(-100%);
    }
    to {
      transform: translateY(0);
    }
  }

  &.header-sticky,
  &.header-main-menu-open {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    opacity: 1;
  }

  &.header-sticky {
    animation: slideIn 0.4s ease forwards;
  }

  &.standard,
  &.header-sticky {
    header {
      border-bottom: 1px solid ${baseVariables.color['neutral20']};
    }
  }

  &.is-overlay {
    z-index: 51; // so it appears above searchform
  }

  .primary-navigation-wrapper {
    order: -1;

    @media ${baseVariables.mediaQuery.desktop} {
      flex: 1;
      order: 0;
    }
  }

  .utility-links-wrapper {
    display: flex;
    align-items: center;
    justify-self: flex-end;
  }

  .navigation-logo-container {
    flex: 1;

    @media ${baseVariables.mediaQuery.md} {
      // the "Marriott(R)" part of the logo not including the squiggly M is 108px wide,
      // so just hard-code that here so there's no magic positioning required to create space
      width: ${toRem(108)};
    }

    @media ${baseVariables.mediaQuery.lg} {
      flex: 0;
      margin-right: ${toRem(32)};
    }
  }

  .navigation-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    position: relative;
  }

  .branded-logo-container {
    // TODO: set a width here to override the 108px+32px above
    height: 100%;
    display: flex;
    align-items: center;
    margin-left: ${toRem(24)};
  }

  .h-100 {
    height: 100%;
  }

  .banner-row {
    height: 100%;
  }
`;
